var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defaultMetalCupMaterialTransform, } from "3d/types";
/** ---------------   **/
/**    OBF Family     **/
/** ---------------   **/
export var suctionCupsFamilyOBF = {
    OBF: __assign(__assign({ cupModelName: "OBF3590P", cupWidth: 0.09, cupHeight: 0.035 }, defaultMetalCupMaterialTransform.PU55), { fittingModelName: "NT38F00", collisionComponentType: "capsule" }),
};
